import {RegulationTypes, SlotSettingsParameters} from '@gongxigames/framework/slot';
import {CurrencyData} from '@rubyplay/currency-formatter';
import {PromotionBalanceEntry} from '@gongxigames/framework/promotions';

export type ActionName = 'spin' | 'freespin' | 'pick' | 'select';

export type PromotionDecision = 'accept' | 'ask_me_later' | 'decline';

export type ResponseBody = {
    data: ServerResponseData | any;
    status: string;
    topic: string;
    next_action: ActionName;
    active_promotion_id?: string;
    sessionKey?: string;
    errorCode?: string;
    redirectUrl?: string;
    funModeData?: object;
};

export type ServerResponseData = {
    an?: number;
    binary?: string;
    game_config?: any;
    game_history?: any;
    integrationsPayload?: string;
    next_action?: ActionName;
    player?: PlayerConfig;
    currency_configuration: CurrencyData;
    regulation_settings?: RegulationSettings;
    promotion_settings?: PromotionsSettings;
    buy_feature_available?: boolean;
};

type SlotSettingsParametersForRegulations = Pick<
    SlotSettingsParameters,
    'turboModeDisabled' | 'quickStopDisabled' | 'fullscreenDisabled' | 'soundEnabled' | 'soundsMuted' | 'soundVolume' |
    'gameRulesRealityCheckDisabled' | 'gameRulesSessionsLifeDisabled' | 'autoSpinDisabled' | 'allAutoplayLimitsDisabled' |
    'autoplayStopWhenAnyBonus' | 'autoplaySkipBigWins' | 'autoplaySkipLongSpins' | 'autoplaySkipWinAnimation' | 'autoplayRequiredSingleWin' |
    'autoplayRequiredLossLimit' | 'autoplayRequiredWinLimit' | 'autoplayDefaultSelectedSpins' | 'autoplayValues' | 'autoplayShowBetAndWager' | 'autoplayShowConfirmationPopup' |
    'showBet' | 'showBalance' | 'historyUrl' | 'supportUrl' | 'logoutUrl' | 'cashierUrl' | 'homeUrl' | 'exitUrl' | 'currency' |
    'showWinProbability' | 'hideJackpotWords' | 'hideHomeButtonDescription' | 'minMaxBetVisible' | 'clock' | 'enableDetailedRTP' | 'enableRTPExplanation' | 'hideRTP' |
    'ukRegulations' | 'realityCheckTimeout' | 'realityCheckTimeoutPassed' | 'roundDelay' | 'gameHistoryListEnabled' |
    'showOddsUpfront'| 'regulationType' | 'showRTPWatermark' | 'showMaxMultiplier' | 'disableClientErrorReporting' | 'enableRTPExplanation2' |
    'enableTriggeringJackpotsExplanation' | 'additionalInformationDisabled' | 'gameTerminologyDisabled' | 'disconnectionSectionDisabled' |
    'multiplierSignFirst' | 'gameRulesRealityCheckUKGCStringDisabled' | 'nonMinimalBetPopupEnabled' |
    'gameRulesAdditionalDataAboutLinesWaysEnable' | 'showMaxWinProbabilityOnUI' | 'isPointsCurrencyEnabled' | 'freezeNewTextsUpdate' | 'enablePersistentFeatureExplanation' |
    'enableOpenInSameTabDepositPage'| 'enableOpenPageInCurrentIFrame' | 'searchInfoFeatureEnabled' | 'hideBetPanelDuringAwardedFeature' >;

export type PromotionsSettings = Pick<
    SlotSettingsParameters,
    'freeRoundsValuedAtEnabled' |
    'freeRoundsExpiresInEnabled' |
    'freeRoundsOptOutEnabled' |
    'freeRoundsPlayLaterEnabled' |
    'freeRoundsYouWonEnabled' |
    'freeRoundsOptOutConfirmationPopupEnabled' |
    'awardedFeatureValuedAtEnabled' |
    'awardedFeatureExpiresInEnabled' |
    'awardedFeatureOptOutEnabled' |
    'awardedFeaturePlayLaterEnabled' |
    'awardedFeatureYouWonEnabled' |
    'awardedFeatureOptOutConfirmationPopupEnabled' >;

export type RegulationSettings = {
    regulationType: RegulationTypes;
    delayBetweenSpins?: number;
    pingBalanceIgnoreCache?: boolean;
    pingBalanceDelay?: number;
    celebrationBelowBetDisabled?: boolean;
} & Partial<SlotSettingsParametersForRegulations>;

export type PromotionDecisionRequest = {
    key: string;
    action: string;
    an: number;
    promotion_decision: PromotionDecision;
    promotion_id: string;
};

export type BetsConfig = {
    bets: number[];
    max_bf_bet: number;
    def_bet_index: number;
};

export type PlayerConfig = {
    currency: string;
    subunit: number;
    promotion_balance?: PromotionBalanceEntry[];
};

export const PROMOTION_DECISION_ACTION = 'promotion_decision';
